import AdminAnalytics from '../group/AdminAnalytics';

export default function AdminDashboard() {
  return <AdminAnalytics pageMode="dashboard" />;
}